import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ROUTE_TO_TAB } from './TopTabBar';

const TAB_BOTTOM_NAV = {
    home: [
        { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    ],
    family: [
        { to: '/grocery',               label: 'Grocery',  icon: '🛒' },
        { to: '/todo',                  label: 'Tasks',    icon: '✓'  },
        { to: '/wishlist',              label: 'Wishes',   icon: '🎁' },
        { to: '/appointments',          label: 'Appts',    icon: '📅' },
        { to: '/appointments/calendar', label: 'Calendar', icon: '🗓️' },
    ],
    finances: [
        { to: '/subscriptions', label: 'Subs',   icon: '💳' },
        { to: '/bills',         label: 'Bills',  icon: '📄' },
        { to: '/debts',         label: 'Debts',  icon: '💰' },
        { to: '/assets',        label: 'Assets', icon: '🏠' },
    ],
    resources: [
        { to: '/knowledge-base', label: 'Notes',     icon: '📚' },
        { to: '/recipes',        label: 'Recipes',   icon: '🍽️' },
        { to: '/web-links',      label: 'Links',     icon: '🔗' },
        { to: '/passwords',      label: 'Passwords', icon: '🔐' },
    ],
    admin: [
        { to: '/household',                  label: 'Nest Mgmt', icon: '🏡' },
        { to: '/admin/knowledge-categories', label: 'KB Cats',   icon: '🗂️' },
        { to: '/admin/super',                label: 'Super',     icon: '⚙️', superAdminOnly: true },
    ],
};

function BottomNav({ user }) {
    const location = useLocation();
    const activeTab = ROUTE_TO_TAB[location.pathname] || 'home';
    const allItems = TAB_BOTTOM_NAV[activeTab] || TAB_BOTTOM_NAV.home;
    const items = allItems.filter(item => !item.superAdminOnly || user?.is_super_admin);

    return (
        <nav className="bottom-nav">
            {items.map(item => (
                <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
                >
                    <span className="bottom-nav-icon">{item.icon}</span>
                    {item.label}
                </NavLink>
            ))}
        </nav>
    );
}

export default BottomNav;
